import { render } from "./SeleccionarUnidades.vue?vue&type=template&id=1b150e59"
import script from "./SeleccionarUnidades.vue?vue&type=script&lang=js"
export * from "./SeleccionarUnidades.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__